import { MenuItem, type MenuItemProps } from '@mui/material';
import withPermission from './withPermission';

type AppMenuItemProps = {
  module: string;
  permission?: string;
} & MenuItemProps;

const AppMenuItem = ({ module, permission = 'acceso', ...props }: AppMenuItemProps) => {
  return withPermission(MenuItem, module, permission, false)(props);
};

export default AppMenuItem;
